<div fxFlex fxLayout [fxLayoutGap]="fxLayoutGap" *ngIf="fxFlex">
  <ng-container *ngIf="!outlineStyle; else outlineStyleForm">
    <mat-form-field fxFlex="50" [class.prefix-label]="prefixLabel" [ngClass]="cssClass">
      <span matPrefix *ngIf="prefixLabel">Lat</span>
      <mat-label *ngIf="!prefixLabel">Lat</mat-label>
      <input
        class="e2e-latitude"
        matInput
        (blur)="onblur($event, 'latitude')"
        #latInput
        (focus)="onfocus($event, 'latitude')"
        (keydown)="onkeydown($event)"
        type="text"
        [formControl]="latDisplayCtrl"
        [required]="required"
      />
      <mat-hint *ngIf="latDisplayCtrl.errors">{{ latDisplayCtrl.errors.outOfRangeError }}</mat-hint>
    </mat-form-field>
    <mat-form-field fxFlex="50" [class.prefix-label]="prefixLabel" [ngClass]="cssClass">
      <span matPrefix *ngIf="prefixLabel">Lon</span>
      <mat-label *ngIf="!prefixLabel">Lon</mat-label>
      <input
        matInput
        class="e2e-longitude"
        (blur)="onblur($event, 'longitude')"
        #LngInput
        (focus)="onfocus($event, 'longitude')"
        (keydown)="onkeydown($event)"
        type="text"
        [formControl]="lngDisplayCtrl"
        [required]="required"
      />
      <mat-hint *ngIf="lngDisplayCtrl.errors">{{ lngDisplayCtrl.errors.outOfRangeError }}</mat-hint>
    </mat-form-field>
  </ng-container>
</div>
<div class="inline" *ngIf="!fxFlex">
  <ng-container *ngIf="!outlineStyle; else outlineStyleForm">
    <mat-form-field [class.prefix-label]="prefixLabel" [ngClass]="cssClass">
      <span matPrefix *ngIf="prefixLabel">Lat</span>
      <mat-label *ngIf="!prefixLabel">Lat</mat-label>
      <input
        matInput
        class="e2e-latitude"
        (blur)="onblur($event, 'latitude')"
        #latInput
        (focus)="onfocus($event, 'latitude')"
        (keydown)="onkeydown($event)"
        type="text"
        [formControl]="latDisplayCtrl"
        [required]="required"
      />
      <mat-hint *ngIf="latDisplayCtrl.errors">{{ latDisplayCtrl.errors.outOfRangeError }}</mat-hint>
    </mat-form-field>
    <mat-form-field [class.prefix-label]="prefixLabel" [ngClass]="cssClass">
      <span matPrefix *ngIf="prefixLabel">Lon</span>
      <mat-label *ngIf="!prefixLabel">Lon</mat-label>
      <input
        matInput
        class="e2e-longitude"
        (blur)="onblur($event, 'longitude')"
        #LngInput
        (focus)="onfocus($event, 'longitude')"
        (keydown)="onkeydown($event)"
        type="text"
        [formControl]="lngDisplayCtrl"
        [required]="required"
      />
      <mat-hint *ngIf="lngDisplayCtrl.errors">{{ lngDisplayCtrl.errors.outOfRangeError }}</mat-hint>
    </mat-form-field>
  </ng-container>
</div>
<ng-template #outlineStyleForm>
  <mat-form-field appearance="outline" fxFlex="50" [ngClass]="cssClass">
    <mat-label>Lat</mat-label>
    <input
      class="e2e-latitude"
      matInput
      (blur)="onblur($event, 'latitude')"
      #latInput
      (focus)="onfocus($event, 'latitude')"
      (keydown)="onkeydown($event)"
      type="text"
      [formControl]="latDisplayCtrl"
      [required]="required"
    />
    <mat-hint *ngIf="latDisplayCtrl.errors">{{ latDisplayCtrl.errors.outOfRangeError }}</mat-hint>
  </mat-form-field>
  <mat-form-field appearance="outline" fxFlex="50" [ngClass]="cssClass">
    <mat-label>Lon</mat-label>
    <input
      matInput
      class="e2e-longitude"
      (blur)="onblur($event, 'longitude')"
      #LngInput
      (focus)="onfocus($event, 'longitude')"
      (keydown)="onkeydown($event)"
      type="text"
      [formControl]="lngDisplayCtrl"
      [required]="required"
    />
    <mat-hint *ngIf="lngDisplayCtrl.errors">{{ lngDisplayCtrl.errors.outOfRangeError }}</mat-hint>
  </mat-form-field>
</ng-template>
